// extracted by mini-css-extract-plugin
export default {"preloader":"Loader_preloader__q3wYf","hide":"Loader_hide__-2N8i","loader":"Loader_loader__6xqU0","spin":"Loader_spin__7qsDj"};